module.exports = __webpack_public_path__ + "img/Crayon-de-modification-couleur.fd51b7aa.svg";